// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import TheatreServices from '../../services/externalServices/TicketServices/theatreServices';
// import MovieServices from '../../services/externalServices/TicketServices/moviesServices'
// import DynamicServices from '../../services/externalServices/TicketServices/dynamicServices';
// import {
//     FiHome,
//     FiFilm,
//     FiCalendar,
//     FiCheckSquare,
//     FiSettings,
//     FiGrid
// } from 'react-icons/fi';
// // import { FiSettings, FiCalendar, FiFilm, FiHome, FiCheckSquare, FiDollarSign, FiGrid } from 'react-icons/fi';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";



// const MasterSeatEditor = () => {
//     const [formData, setFormData] = useState({
//         theatreId: '',
//         selectedMovie: '',
//         seatLayout: [],
//         selectedDates: [],
//         selectedShowTimes: {},
//         validityFrom: '',
//         validityUntil: ''
//     });

//     const [theatres, setTheatres] = useState([]);
//     const [movies, setMovies] = useState([]);
//     const [availableShowTimes, setAvailableShowTimes] = useState([]);
//     const [selectedMovie, setSelectedMovie] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [zoom, setZoom] = useState(0.9);
//     const [rowOriginalStates, setRowOriginalStates] = useState({});

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
//     const theatreName = accessList?.[0];

//     // Mouse wheel zoom handler
//     const handleWheel = (e) => {
//         if (e.ctrlKey) {
//             e.preventDefault();
//             handleZoom(e.deltaY > 0 ? 'out' : 'in');
//         }
//     };

//     useEffect(() => {
//         window.addEventListener('wheel', handleWheel, { passive: false });
//         return () => window.removeEventListener('wheel', handleWheel);
//     }, [zoom]);

//     useEffect(() => {
//         const fetchTheatres = async () => {
//             const res = await TheatreServices.getTheatres();
//             if (Array.isArray(res)) {
//                 let filtered = res;
//                 if (role === "ticket-admin") {
//                     filtered = res.filter(t => accessList.includes(t.name));
//                 }
//                 setTheatres(filtered);
//                 if (filtered.length > 0) {
//                     setFormData(prev => ({ ...prev, theatreId: filtered[0]._id }));
//                 }
//             }
//         };

//         fetchTheatres();
//     }, []);

//     useEffect(() => {
//         const fetchAndFilterMovies = async () => {
//             if (!formData.theatreId) return;
//             const allMovies = await MovieServices.getMovies(theatreName);
//             const filtered = allMovies.filter(movie =>
//                 movie.availableIn?.some(t => t._id === formData.theatreId)
//             );
//             setMovies(filtered);
//         };

//         fetchAndFilterMovies();
//     }, [formData.theatreId]);

//     useEffect(() => {
//         const fetchShowTimes = async () => {
//             setLoading(true);
//             try {
//                 if (selectedMovie && formData.theatreId) {
//                     const res = await DynamicServices.getDynamicShowSchedules({
//                         theatreName,
//                         movieId: selectedMovie,
//                         theatreId: formData.theatreId,
//                     });

//                     if (Array.isArray(res) && res.length > 0) {
//                         const theatreDetails = res[0].theatreDetails?.[0];
//                         if (theatreDetails) {
//                             const formattedTimes = (theatreDetails.shows || []).map(show => show.time);
//                             setAvailableShowTimes(formattedTimes);

//                             setFormData(prev => ({
//                                 ...prev,
//                                 validityFrom: res[0].validityFrom,
//                                 validityUntil: res[0].validityUntil
//                             }));
//                         }
//                     }
//                 }
//             } catch (err) {
//                 console.error("Error fetching showtimes:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchShowTimes();
//     }, [selectedMovie, formData.theatreId]);

//     // const handleShowtimeToggle = async (date, time, checked) => {
//     //     setFormData(prev => {
//     //         const times = prev.selectedShowTimes[date] || [];
//     //         const updatedTimes = checked
//     //             ? [...times, time]
//     //             : times.filter(t => t !== time);

//     //         return {
//     //             ...prev,
//     //             selectedShowTimes: {
//     //                 ...prev.selectedShowTimes,
//     //                 [date]: updatedTimes
//     //             }
//     //         };
//     //     });

//     //     if (checked) {
//     //         try {
//     //             setLoading(true);
//     //             const res = await axios.get(`http://localhost:4123/api/master/layout?theatreId=${formData.theatreId}`);

//     //             if (res.data && res.data.seatLayout) {
//     //                 setFormData(prev => ({
//     //                     ...prev,
//     //                     seatLayout: res.data.seatLayout
//     //                 }));
//     //             }
//     //         } catch (error) {
//     //             console.error('Error fetching seat layout:', error);
//     //         } finally {
//     //             setLoading(false);
//     //         }
//     //     }
//     // };



//     const handleShowtimeToggle = async (date, time, checked) => {
//         setFormData(prev => {
//             const times = prev.selectedShowTimes[date] || [];
//             const updatedTimes = checked
//                 ? [...times, time]
//                 : times.filter(t => t !== time);

//             return {
//                 ...prev,
//                 selectedShowTimes: {
//                     ...prev.selectedShowTimes,
//                     [date]: updatedTimes
//                 }
//             };
//         });

//         if (checked) {
//             try {
//                 setLoading(true);

//                 console.log('formData.theatreId,selectedMovie,date,time', formData.theatreId, selectedMovie, date, time)
//                 // const res = await axios.get(`http://localhost:4123/api/master/layout`, {
//                 //     params: {
//                 //         theatreId: formData.theatreId,
//                 //         movieId: selectedMovie,
//                 //         date: date,
//                 //         showtimeId: time
//                 //     }
//                 // });


//                 const res = await DynamicServices.getMasterSeatsLayout({
//                     theatreId: formData.theatreId,
//                     movieId: selectedMovie,
//                     date: date,
//                     showtimeId: time
//                 });



//                 console.log('res.data', res);



//                 if (res && res.layout) {
//                     setFormData(prev => ({
//                         ...prev,
//                         // seatLayout: res.data.layout,
//                         // layoutId: res.data.layout._id  // ✅ store layout _id for later update
//                         seatLayout: res.layout.seatLayout,
//                         layoutId: res.layout._id, // ✅ this is what must be set
//                     }));
//                 }
//             } catch (error) {
//                 console.error('Error fetching seat layout:', error);
//             } finally {
//                 setLoading(false);
//             }
//         }
//     };

//     const toggleSeat = (sectionIdx, seatIdx) => {
//         const updated = [...formData.seatLayout];
//         const seat = updated[sectionIdx].Seats[seatIdx];
//         seat.Stat = seat.Stat === 1 ? 0 : 1;
//         setFormData(prev => ({ ...prev, seatLayout: updated }));
//     };

//     const handleRowCheckboxChange = (sectionIdx, row, checked) => {
//         const rowKey = `${sectionIdx}_${row}`;
//         const updated = [...formData.seatLayout];
//         const seatsInRow = updated[sectionIdx].Seats.filter((s) => s.Row === row && s.Col !== 'X');

//         if (checked) {
//             if (!rowOriginalStates[rowKey]) {
//                 setRowOriginalStates(prev => ({
//                     ...prev,
//                     [rowKey]: seatsInRow.map(s => s.Stat),
//                 }));
//             }
//             seatsInRow.forEach(s => s.Stat = 0);
//         } else {
//             const original = rowOriginalStates[rowKey];
//             if (original) {
//                 seatsInRow.forEach((s, idx) => {
//                     s.Stat = original[idx];
//                 });
//             } else {
//                 seatsInRow.forEach(s => s.Stat = 1);
//             }
//             setRowOriginalStates(prev => {
//                 const next = { ...prev };
//                 delete next[rowKey];
//                 return next;
//             });
//         }

//         setFormData(prev => ({ ...prev, seatLayout: updated }));
//     };

//     const handleZoom = (direction) => {
//         setZoom(prev => {
//             const newZoom = direction === 'in' ? prev + 0.1 : prev - 0.1;
//             return Math.min(Math.max(newZoom, 0.7), 1.5);
//         });
//     };

//     // const updateLayout = () => {


//     //     const layoutId = formData.layoutId; // you must have this from DB

//     //     console.log('formData.layoutid',layoutId);

//     //     axios.put(`http://localhost:4123/api/master/layout/${layoutId}`, {
//     //         movieId: formData.movieId,
//     //         seatLayout: formData.seatLayout,
//     //         date: formData.selectedDates,
//     //         showtimeId: formData.selectedShowTimes
//     //     })
//     //         .then(() => alert('Master layout updated successfully!'))
//     //         .catch((err) => {
//     //             console.error('Update error:', err);
//     //             alert('Error updating layout');
//     //         });
//     // };



//     // const updateLayout = () => {
//     //     const layoutId = formData.layoutId;

//     //     const selectedDate = Object.keys(formData.selectedShowTimes)[0];
//     //     const selectedTime = formData.selectedShowTimes[selectedDate]?.[0];

//     //     if (!layoutId || !selectedDate || !selectedTime) {
//     //       alert('Missing layoutId, date, or time!');
//     //       return;
//     //     }

//     //     DynamicServices.updateMasterSeatLayout({
//     //       layoutId: layoutId,
//     //       movieId: selectedMovie,
//     //       seatLayout: formData.seatLayout,
//     //       date: selectedDate,
//     //       showtimeId: selectedTime,
//     //     })
//     //       .then(() => {
//     //         alert('Layout updated successfully!');
//     //       })
//     //       .catch((err) => {
//     //         console.error('Update error:', err?.response?.data || err);
//     //         alert('Error updating layout');
//     //       });
//     //   };

//     const updateLayout = () => {
//         const layoutId = formData.layoutId;
//         const selectedDate = Object.keys(formData.selectedShowTimes)[0];
//         const selectedTime = formData.selectedShowTimes[selectedDate]?.[0];

//         if (!layoutId || !selectedDate || !selectedTime) {
//             alert('Missing layoutId, date, or time!');
//             return;
//         }

//         DynamicServices.updateMasterSeatLayout({
//             layoutId,
//             movieId: selectedMovie,
//             theatreId: formData.theatreId,
//             seatLayout: formData.seatLayout,
//             date: selectedDate,
//             showtimeId: selectedTime,
//         })
//             .then((response) => {

//                 console.log('response in then', response)
//                 const message = response?.message;
//                 alert(message);
//             })
//             .catch((err) => {
//                 console.log('response in catch', err)
//                 const errorMessage = err?.response?.message || '❌ Error updating layout';
//                 console.error('Update error:', err?.response || err);
//                 alert(errorMessage);
//             });
//     };



//     const clearFormData = () => {
//         setSelectedMovie('');
//         setAvailableShowTimes([]);
//         setFormData({
//             theatreId: '',
//             selectedMovie: '',
//             seatLayout: [],
//             selectedDates: [],
//             selectedShowTimes: {},
//             validityFrom: '',
//             validityUntil: ''
//         });
//     };

//     // const getSeatStyle = (stat, isHighlighted) => {
//     //     const baseStyle = 'w-5 h-5 flex items-center justify-center rounded-sm text-[10px] mx-px cursor-pointer transition-colors';

//     //     switch (stat) {
//     //         case 0: // Blocked
//     //             return `${baseStyle} bg-gray-200 border border-gray-400 text-gray-600 hover:bg-gray-300`;
//     //         case 1: // Available
//     //             return `${baseStyle} border-1 border-emerald-400 bg-white text-gray-600 hover:bg-green-50 ${isHighlighted ? 'ring-2 ring-yellow-400' : ''}`;
//     //         default:
//     //             return `${baseStyle} bg-white border border-gray-300`;
//     //     }
//     // };

//     const getSeatStyle = (stat, isHighlighted) => {
//         const baseStyle = 'w-5 h-5 flex items-center justify-center rounded-sm text-[10px] mx-px cursor-pointer transition-colors';

//         switch (stat) {
//           case 0: // Blocked
//             return `${baseStyle} bg-gray-200 border border-gray-400 text-gray-600 hover:bg-gray-300`;
//           case 1: // Available
//             return `${baseStyle} border-1 border-emerald-400 bg-white text-gray-600 hover:bg-green-50 ${isHighlighted ? 'ring-2 ring-yellow-400' : ''}`;
//           case 2: // Booked
//             return `${baseStyle} bg-gray-400 border border-gray-600 text-white cursor-not-allowed`; // Booked seat style
//           default:
//             return `${baseStyle} bg-white border border-gray-300`;
//         }
//       };


//     return (
//         <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-8">
//             <div className="max-w-7xl mx-auto">
//                 <div className="mb-12 text-center">
//                     <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
//                         <FiGrid className="text-blue-600" />
//                         Master Screen Layout Editor
//                     </h1>
//                     <p className="text-lg text-gray-600">Manage seat configurations for all showtimes</p>
//                 </div>

//                 <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8">
//                     <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
//                         <div className="space-y-4">
//                             <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
//                                 <FiHome /> Select Theatre
//                             </h3>
//                             <select
//                                 value={formData.theatreId}
//                                 onChange={(e) => {
//                                     const theatreId = e.target.value;
//                                     setFormData(prev => ({ ...prev, theatreId }));
//                                     setSelectedMovie('');
//                                 }}
//                                 className="w-full px-4 py-3 rounded-xl border border-gray-200"
//                             >
//                                 <option value="">Choose Theatre...</option>
//                                 {theatres.map(t => (
//                                     <option key={t._id} value={t._id}>{t.name}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="space-y-4">
//                             <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
//                                 <FiFilm /> Select Movie
//                             </h3>
//                             <select
//                                 value={selectedMovie}
//                                 onChange={(e) => setSelectedMovie(e.target.value)}
//                                 className="w-full px-4 py-3 rounded-xl border border-gray-200"
//                             >
//                                 <option value="">Choose Movie...</option>
//                                 {movies.map(m => (
//                                     <option key={m._id} value={m._id}>{m.name}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>

//                     {loading ? (
//                         <div className="flex justify-center py-12">
//                             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//                         </div>
//                     ) : availableShowTimes.length === 0 ? (
//                         <div className="text-center py-12 bg-gray-50 rounded-xl">
//                             <div className="text-gray-400 mb-4 text-6xl">🎬</div>
//                             <h3 className="text-xl font-semibold text-gray-800 mb-2">No Screenings Available</h3>
//                             <p className="text-gray-600">Please select a theatre and movie to view schedules</p>
//                         </div>
//                     ) : (
//                         <>
//                             {/* Date Picker and Showtimes */}
//                             <div className="grid grid-cols-1 xl:grid-cols-[290px_1fr] gap-8 mb-12">
//                                 <div className="bg-gray-50 p-6 rounded-xl">
//                                     <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
//                                         <FiCalendar /> Schedule Dates
//                                     </h3>
//                                     <DatePicker
//                                         inline
//                                         selected={null}
//                                         onSelect={(date) => {
//                                             const iso = date.toLocaleDateString('en-CA');
//                                             setFormData(prev => {
//                                                 const isSelected = prev.selectedDates.includes(iso);
//                                                 const updatedDates = isSelected
//                                                     ? prev.selectedDates.filter(d => d !== iso)
//                                                     : [...prev.selectedDates, iso];
//                                                 const updatedTimes = { ...prev.selectedShowTimes };
//                                                 if (!updatedDates.includes(iso)) delete updatedTimes[iso];
//                                                 return {
//                                                     ...prev,
//                                                     selectedDates: updatedDates,
//                                                     selectedShowTimes: updatedTimes
//                                                 };
//                                             });
//                                         }}
//                                         highlightDates={formData.selectedDates.map(d => new Date(d))}
//                                         minDate={formData.validityFrom ? new Date(formData.validityFrom) : null}
//                                         maxDate={formData.validityUntil ? new Date(formData.validityUntil) : null}
//                                     />
//                                 </div>

//                                 {/* Showtimes */}
//                                 <div>
//                                     <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
//                                         <FiCheckSquare /> Select Showtimes
//                                     </h3>
//                                     <div className="space-y-4">
//                                         {formData.selectedDates.map(date => (
//                                             <div key={date} className="border p-4 rounded-xl bg-white">
//                                                 <h4 className="text-sm font-semibold mb-3 text-gray-700">
//                                                     {new Date(date).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
//                                                 </h4>
//                                                 <div className="grid grid-cols-2 gap-2">
//                                                     {availableShowTimes.map(time => {
//                                                         const checked = formData.selectedShowTimes[date]?.includes(time) || false;
//                                                         return (
//                                                             <label key={time} className={`flex items-center gap-2 p-2 rounded-lg ${checked ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'}`}>
//                                                                 <input
//                                                                     type="checkbox"
//                                                                     checked={checked}
//                                                                     onChange={() => handleShowtimeToggle(date, time, !checked)}
//                                                                 />
//                                                                 {time}
//                                                             </label>
//                                                         );
//                                                     })}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Seat Layout Editor */}
//                             <div className="space-y-6">
//                                 <div className="flex items-center justify-between mb-6">
//                                     <div className="flex items-center gap-3">
//                                         <div className="p-3 bg-pink-100 rounded-lg">
//                                             <FiGrid className="text-2xl text-pink-600" />
//                                         </div>
//                                         <h3 className="text-xl font-semibold text-gray-800">
//                                             Seat Layout Configuration
//                                         </h3>
//                                     </div>
//                                     <div className="flex items-center gap-4">
//                                         <button
//                                             onClick={() => handleZoom('out')}
//                                             className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 disabled:opacity-50 transition-colors"
//                                             disabled={zoom <= 0.7}
//                                         >
//                                             -
//                                         </button>
//                                         <span className="text-sm w-16 text-center">Zoom: {Math.round(zoom * 100)}%</span>
//                                         <button
//                                             onClick={() => handleZoom('in')}
//                                             className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 disabled:opacity-50 transition-colors"
//                                             disabled={zoom >= 1.5}
//                                         >
//                                             +
//                                         </button>
//                                     </div>
//                                 </div>

//                                 <div className="flex gap-4 mb-4 text-xs text-gray-600">
//                                     <div className="flex items-center gap-1">
//                                         <div className="w-4 h-4 border border-emerald-500"></div> Available
//                                     </div>
//                                     <div className="flex items-center gap-1">
//                                         <div className="w-4 h-4 bg-gray-300 border border-gray-400"></div> Blocked
//                                     </div>
//                                 </div>

//                                 {formData.seatLayout.length > 0 ? (
//                                     <div className="overflow-auto" onWheel={handleWheel}>
//                                         <div
//                                             className="mx-auto bg-gray-50 p-6 rounded-xl"
//                                             style={{
//                                                 transform: `scale(${zoom})`,
//                                                 transformOrigin: 'top center',
//                                                 width: 'fit-content'
//                                             }}
//                                         >
//                                             {formData.seatLayout.map((section, sIdx) => (
//                                                 <div key={sIdx} className="mb-8">
//                                                     <h3 className="text-center font-poppins font-medium text-sm text-black mb-2">
//                                                         {section.Name} {section.Price > 0 && `- Rs. ${section.Price}`}
//                                                     </h3>

//                                                     <div className="flex flex-col items-center">
//                                                         {Array.from(new Set(section.Seats.map((s) => s.Row))).map((row) => {
//                                                             const rowKey = `${sIdx}_${row}`;
//                                                             const isBlocking = section.Seats.filter(s => s.Row === row && s.Col !== 'X').every(s => s.Stat === 0);

//                                                             return (
//                                                                 <div key={row} className="flex items-center mb-1">
//                                                                     <span className="w-6 text-xs font-medium mr-1">{row}</span>
//                                                                     <div className="flex">
//                                                                         {section.Seats.filter((s) => s.Row === row).map((seat, seatIdx) => {
//                                                                             const globalSeatIdx = section.Seats.findIndex(
//                                                                                 (s) => s.Row === seat.Row && s.Col === seat.Col
//                                                                             );

//                                                                             if (seat.Col === 'X') {
//                                                                                 return <div key={seatIdx} className="w-5 h-5 mx-px" />;
//                                                                             }

//                                                                             return (
//                                                                                 // <div
//                                                                                 //     key={seatIdx}
//                                                                                 //     onClick={() => toggleSeat(sIdx, globalSeatIdx)}
//                                                                                 //     className={getSeatStyle(seat.Stat, isBlocking && seat.Stat === 1)}
//                                                                                 // >
//                                                                                 //     {seat.Col}
//                                                                                 // </div>

//                                                                                 <div
//                                                                                     key={seatIdx}
//                                                                                     onClick={seat.Stat === 2 ? undefined : () => toggleSeat(sIdx, globalSeatIdx)}
//                                                                                     className={`${getSeatStyle(seat.Stat, isBlocking && seat.Stat === 1)} ${seat.Stat === 2 ? 'cursor-not-allowed opacity-60' : ''}`}
//                                                                                     title={seat.Stat === 2 ? 'Booked Seat - Cannot Modify' : ''}
//                                                                                 >
//                                                                                     {seat.Col}
//                                                                                 </div>

//                                                                             );
//                                                                         })}
//                                                                     </div>

//                                                                     {section.Seats.some(s => s.Row === row && s.Col !== 'X') && (
//                                                                         <input
//                                                                             type="checkbox"
//                                                                             className="ml-2"
//                                                                             checked={isBlocking}
//                                                                             onChange={(e) => handleRowCheckboxChange(sIdx, row, e.target.checked)}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="text-center py-8 text-gray-500">
//                                         Select a showtime to load the seat layout
//                                     </div>
//                                 )}
//                             </div>
//                         </>
//                     )}

//                     {/* Validation & Actions */}
//                     <div className="mt-12 pt-8 border-t border-gray-200">
//                         {formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) && (
//                             <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6 rounded-lg">
//                                 <div className="flex items-center gap-3">
//                                     <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
//                                         <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                                     </svg>
//                                     <span className="text-red-700">Please select at least one showtime for each selected date</span>
//                                 </div>
//                             </div>
//                         )}

//                         <div className="flex flex-col sm:flex-row justify-end gap-4">
//                             <button
//                                 onClick={clearFormData}
//                                 className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
//                             >
//                                 Reset Configuration
//                             </button>
//                             <button
//                                 onClick={updateLayout}
//                                 disabled={formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) || formData.seatLayout.length === 0}
//                                 className={`px-6 py-3 rounded-xl transition-all ${formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) || formData.seatLayout.length === 0
//                                     ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                                     : 'bg-black text-white shadow-lg hover:shadow-xl'
//                                     }`}
//                             >
//                                 Update Master Layout
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MasterSeatEditor;









import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import TheatreServices from '../../services/externalServices/TicketServices/theatreServices';
import MovieServices from '../../services/externalServices/TicketServices/moviesServices'
import DynamicServices from '../../services/externalServices/TicketServices/dynamicServices';
import {
    FiHome,
    FiFilm,
    FiCalendar,
    FiCheckSquare,
    FiSettings,
    FiGrid
} from 'react-icons/fi';
// import { FiSettings, FiCalendar, FiFilm, FiHome, FiCheckSquare, FiDollarSign, FiGrid } from 'react-icons/fi';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



const MasterSeatEditor = () => {
    const [formData, setFormData] = useState({
        theatreId: '',
        selectedMovie: '',
        seatLayout: [],
        selectedDates: [],
        selectedShowTimes: {},
        validityFrom: '',
        validityUntil: ''
    });

    const [theatres, setTheatres] = useState([]);
    const [movies, setMovies] = useState([]);
    const [availableShowTimes, setAvailableShowTimes] = useState([]);
    const [selectedMovie, setSelectedMovie] = useState('');
    const [loading, setLoading] = useState(false);
    const [zoom, setZoom] = useState(0.9);
    const [rowOriginalStates, setRowOriginalStates] = useState({});

    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');
    const theatreName = accessList?.[0];

    // Mouse wheel zoom handler
    const handleWheel = (e) => {
        if (e.ctrlKey) {
            e.preventDefault();
            handleZoom(e.deltaY > 0 ? 'out' : 'in');
        }
    };

    useEffect(() => {
        window.addEventListener('wheel', handleWheel, { passive: false });
        return () => window.removeEventListener('wheel', handleWheel);
    }, [zoom]);

    useEffect(() => {
        const fetchTheatres = async () => {
            const res = await TheatreServices.getTheatres();
            if (Array.isArray(res)) {
                let filtered = res;
                if (role === "ticket-admin") {
                    filtered = res.filter(t => accessList.includes(t.name));
                }
                setTheatres(filtered);
                if (filtered.length > 0) {
                    setFormData(prev => ({ ...prev, theatreId: filtered[0]._id }));
                }
            }
        };

        fetchTheatres();
    }, []);

    useEffect(() => {
        const fetchAndFilterMovies = async () => {
            if (!formData.theatreId) return;
            const allMovies = await MovieServices.getMovies(theatreName);
            const filtered = allMovies.filter(movie =>
                movie.availableIn?.some(t => t._id === formData.theatreId)
            );
            setMovies(filtered);
        };

        fetchAndFilterMovies();
    }, [formData.theatreId]);

    useEffect(() => {
        const fetchShowTimes = async () => {
            setLoading(true);
            try {
                if (selectedMovie && formData.theatreId) {
                    const res = await DynamicServices.getDynamicShowSchedules({
                        theatreName,
                        movieId: selectedMovie,
                        theatreId: formData.theatreId,
                    });

                    if (Array.isArray(res) && res.length > 0) {
                        const theatreDetails = res[0].theatreDetails?.[0];
                        if (theatreDetails) {
                            const formattedTimes = (theatreDetails.shows || []).map(show => show.time);
                            setAvailableShowTimes(formattedTimes);

                            setFormData(prev => ({
                                ...prev,
                                validityFrom: res[0].validityFrom,
                                validityUntil: res[0].validityUntil
                            }));
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching showtimes:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchShowTimes();
    }, [selectedMovie, formData.theatreId]);

    // const handleShowtimeToggle = async (date, time, checked) => {
    //     setFormData(prev => {
    //         const times = prev.selectedShowTimes[date] || [];
    //         const updatedTimes = checked
    //             ? [...times, time]
    //             : times.filter(t => t !== time);

    //         return {
    //             ...prev,
    //             selectedShowTimes: {
    //                 ...prev.selectedShowTimes,
    //                 [date]: updatedTimes
    //             }
    //         };
    //     });

    //     if (checked) {
    //         try {
    //             setLoading(true);
    //             const res = await axios.get(`http://localhost:4123/api/master/layout?theatreId=${formData.theatreId}`);

    //             if (res.data && res.data.seatLayout) {
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     seatLayout: res.data.seatLayout
    //                 }));
    //             }
    //         } catch (error) {
    //             console.error('Error fetching seat layout:', error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     }
    // };



    const handleShowtimeToggle = async (date, time, checked) => {
        setFormData(prev => {
            const times = prev.selectedShowTimes[date] || [];
            const updatedTimes = checked
                ? [...times, time]
                : times.filter(t => t !== time);

            return {
                ...prev,
                selectedShowTimes: {
                    ...prev.selectedShowTimes,
                    [date]: updatedTimes
                }
            };
        });

        if (checked) {
            try {
                setLoading(true);

                console.log('formData.theatreId,selectedMovie,date,time', formData.theatreId, selectedMovie, date, time)
                // const res = await axios.get(`http://localhost:4123/api/master/layout`, {
                //     params: {
                //         theatreId: formData.theatreId,
                //         movieId: selectedMovie,
                //         date: date,
                //         showtimeId: time
                //     }
                // });


                const res = await DynamicServices.getMasterSeatsLayout({
                    theatreId: formData.theatreId,
                    movieId: selectedMovie,
                    date: date,
                    showtimeId: time
                });



                console.log('res.data', res);



                if (res && res.layout) {
                    setFormData(prev => ({
                        ...prev,
                        // seatLayout: res.data.layout,
                        // layoutId: res.data.layout._id  // ✅ store layout _id for later update
                        seatLayout: res.layout.seatLayout,
                        layoutId: res.layout._id, // ✅ this is what must be set
                    }));
                }
            } catch (error) {
                console.error('Error fetching seat layout:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    const toggleSeat = (sectionIdx, seatIdx) => {
        const updated = [...formData.seatLayout];
        const seat = updated[sectionIdx].Seats[seatIdx];
        seat.Stat = seat.Stat === 1 ? 0 : 1;
        setFormData(prev => ({ ...prev, seatLayout: updated }));
    };

    // const handleRowCheckboxChange = (sectionIdx, row, checked) => {
    //     const rowKey = `${sectionIdx}_${row}`;
    //     const updated = [...formData.seatLayout];
    //     const seatsInRow = updated[sectionIdx].Seats.filter((s) => s.Row === row && s.Col !== 'X');

    //     if (checked) {
    //         if (!rowOriginalStates[rowKey]) {
    //             setRowOriginalStates(prev => ({
    //                 ...prev,
    //                 [rowKey]: seatsInRow.map(s => s.Stat),
    //             }));
    //         }
    //         seatsInRow.forEach(s => s.Stat = 0);
    //     } else {
    //         const original = rowOriginalStates[rowKey];
    //         if (original) {
    //             seatsInRow.forEach((s, idx) => {
    //                 s.Stat = original[idx];
    //             });
    //         } else {
    //             seatsInRow.forEach(s => s.Stat = 1);
    //         }
    //         setRowOriginalStates(prev => {
    //             const next = { ...prev };
    //             delete next[rowKey];
    //             return next;
    //         });
    //     }

    //     setFormData(prev => ({ ...prev, seatLayout: updated }));
    // };


    const handleRowCheckboxChange = (sectionIdx, row, checked) => {
        const rowKey = `${sectionIdx}_${row}`;
        const updated = [...formData.seatLayout];
    
        // Get all seats in the row except gaps and booked/reserved seats
        const seatsInRow = updated[sectionIdx].Seats.filter((s) =>
            s.Row === row && s.Col !== 'X' && s.Stat !== 2 && s.Stat !== 3
        );
    
        if (checked) {
            // Save original states of all toggleable seats
            if (!rowOriginalStates[rowKey]) {
                setRowOriginalStates(prev => ({
                    ...prev,
                    [rowKey]: seatsInRow.map(s => s.Stat),
                }));
            }
            // Block all toggleable seats
            seatsInRow.forEach(s => s.Stat = 0);
        } else {
            const original = rowOriginalStates[rowKey];
            if (original) {
                // Restore original states for all seats that were saved
                seatsInRow.forEach((s, idx) => {
                    if (idx < original.length) {
                        s.Stat = original[idx];
                    }
                });
            } else {
                // If no original state saved, unblock all blocked seats
                seatsInRow.forEach(s => {
                    if (s.Stat === 0) {
                        s.Stat = 1;
                    }
                });
            }
            
            // Remove the saved state
            setRowOriginalStates(prev => {
                const next = { ...prev };
                delete next[rowKey];
                return next;
            });
        }
    
        setFormData(prev => ({ ...prev, seatLayout: updated }));
    };
    




    const handleZoom = (direction) => {
        setZoom(prev => {
            const newZoom = direction === 'in' ? prev + 0.1 : prev - 0.1;
            return Math.min(Math.max(newZoom, 0.7), 1.5);
        });
    };

    // const updateLayout = () => {


    //     const layoutId = formData.layoutId; // you must have this from DB

    //     console.log('formData.layoutid',layoutId);

    //     axios.put(`http://localhost:4123/api/master/layout/${layoutId}`, {
    //         movieId: formData.movieId,
    //         seatLayout: formData.seatLayout,
    //         date: formData.selectedDates,
    //         showtimeId: formData.selectedShowTimes
    //     })
    //         .then(() => alert('Master layout updated successfully!'))
    //         .catch((err) => {
    //             console.error('Update error:', err);
    //             alert('Error updating layout');
    //         });
    // };



    // const updateLayout = () => {
    //     const layoutId = formData.layoutId;

    //     const selectedDate = Object.keys(formData.selectedShowTimes)[0];
    //     const selectedTime = formData.selectedShowTimes[selectedDate]?.[0];

    //     if (!layoutId || !selectedDate || !selectedTime) {
    //       alert('Missing layoutId, date, or time!');
    //       return;
    //     }

    //     DynamicServices.updateMasterSeatLayout({
    //       layoutId: layoutId,
    //       movieId: selectedMovie,
    //       seatLayout: formData.seatLayout,
    //       date: selectedDate,
    //       showtimeId: selectedTime,
    //     })
    //       .then(() => {
    //         alert('Layout updated successfully!');
    //       })
    //       .catch((err) => {
    //         console.error('Update error:', err?.response?.data || err);
    //         alert('Error updating layout');
    //       });
    //   };

    const updateLayout = () => {
        const layoutId = formData.layoutId;
        const selectedDate = Object.keys(formData.selectedShowTimes)[0];
        const selectedTime = formData.selectedShowTimes[selectedDate]?.[0];

        if (!layoutId || !selectedDate || !selectedTime) {
            alert('Missing layoutId, date, or time!');
            return;
        }

        DynamicServices.updateMasterSeatLayout({
            layoutId,
            movieId: selectedMovie,
            theatreId: formData.theatreId,
            seatLayout: formData.seatLayout,
            date: selectedDate,
            showtimeId: selectedTime,
        })
            .then((response) => {

                console.log('response in then', response)
                const message = response?.message;
                alert(message);
            })
            .catch((err) => {
                console.log('response in catch', err)
                const errorMessage = err?.response?.message || '❌ Error updating layout';
                console.error('Update error:', err?.response || err);
                alert(errorMessage);
            });
    };



    const clearFormData = () => {
        setSelectedMovie('');
        setAvailableShowTimes([]);
        setFormData({
            theatreId: '',
            selectedMovie: '',
            seatLayout: [],
            selectedDates: [],
            selectedShowTimes: {},
            validityFrom: '',
            validityUntil: ''
        });
    };

    // const getSeatStyle = (stat, isHighlighted) => {
    //     const baseStyle = 'w-5 h-5 flex items-center justify-center rounded-sm text-[10px] mx-px cursor-pointer transition-colors';

    //     switch (stat) {
    //         case 0: // Blocked
    //             return `${baseStyle} bg-gray-200 border border-gray-400 text-gray-600 hover:bg-gray-300`;
    //         case 1: // Available
    //             return `${baseStyle} border-1 border-emerald-400 bg-white text-gray-600 hover:bg-green-50 ${isHighlighted ? 'ring-2 ring-yellow-400' : ''}`;
    //         default:
    //             return `${baseStyle} bg-white border border-gray-300`;
    //     }
    // };

    const getSeatStyle = (stat, isHighlighted) => {
        const baseStyle = 'w-5 h-5 flex items-center justify-center rounded-sm text-[10px] mx-px cursor-pointer transition-colors';

        switch (stat) {
            case 0: // Blocked
                return `${baseStyle} bg-gray-200 border border-gray-400 text-gray-600 hover:bg-gray-300`;
            case 1: // Available
                return `${baseStyle} border-1 border-emerald-400 bg-white text-gray-600 hover:bg-green-50 ${isHighlighted ? 'ring-2 ring-yellow-400' : ''}`;
            case 2: // Booked
                return `${baseStyle} bg-gray-400 border border-gray-600 text-white cursor-not-allowed`; // Booked seat style
            default:
                return `${baseStyle} bg-white border border-gray-300`;
        }
    };


    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-8">
            <div className="max-w-7xl mx-auto">
                <div className="mb-12 text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
                        <FiGrid className="text-blue-600" />
                        Master Screen Layout Editor
                    </h1>
                    <p className="text-lg text-gray-600">Manage seat configurations for all showtimes</p>
                </div>

                <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                        <div className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                <FiHome /> Select Theatre
                            </h3>
                            <select
                                value={formData.theatreId}
                                onChange={(e) => {
                                    const theatreId = e.target.value;
                                    setFormData(prev => ({ ...prev, theatreId }));
                                    setSelectedMovie('');
                                }}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            >
                                <option value="">Choose Theatre...</option>
                                {theatres.map(t => (
                                    <option key={t._id} value={t._id}>{t.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                <FiFilm /> Select Movie
                            </h3>
                            <select
                                value={selectedMovie}
                                onChange={(e) => setSelectedMovie(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            >
                                <option value="">Choose Movie...</option>
                                {movies.map(m => (
                                    <option key={m._id} value={m._id}>{m.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {loading ? (
                        <div className="flex justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                        </div>
                    ) : availableShowTimes.length === 0 ? (
                        <div className="text-center py-12 bg-gray-50 rounded-xl">
                            <div className="text-gray-400 mb-4 text-6xl">🎬</div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">No Screenings Available</h3>
                            <p className="text-gray-600">Please select a theatre and movie to view schedules</p>
                        </div>
                    ) : (
                        <>
                            {/* Date Picker and Showtimes */}
                            <div className="grid grid-cols-1 xl:grid-cols-[290px_1fr] gap-8 mb-12">
                                <div className="bg-gray-50 p-6 rounded-xl">
                                    <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                                        <FiCalendar /> Schedule Dates
                                    </h3>
                                    <DatePicker
                                        inline
                                        selected={null}
                                        onSelect={(date) => {
                                            const iso = date.toLocaleDateString('en-CA');
                                            setFormData(prev => {
                                                const isSelected = prev.selectedDates.includes(iso);
                                                const updatedDates = isSelected
                                                    ? prev.selectedDates.filter(d => d !== iso)
                                                    : [...prev.selectedDates, iso];
                                                const updatedTimes = { ...prev.selectedShowTimes };
                                                if (!updatedDates.includes(iso)) delete updatedTimes[iso];
                                                return {
                                                    ...prev,
                                                    selectedDates: updatedDates,
                                                    selectedShowTimes: updatedTimes
                                                };
                                            });
                                        }}
                                        highlightDates={formData.selectedDates.map(d => new Date(d))}
                                        minDate={formData.validityFrom ? new Date(formData.validityFrom) : null}
                                        maxDate={formData.validityUntil ? new Date(formData.validityUntil) : null}
                                    />
                                </div>

                                {/* Showtimes */}
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                                        <FiCheckSquare /> Select Showtimes
                                    </h3>
                                    <div className="space-y-4">
                                        {formData.selectedDates.map(date => (
                                            <div key={date} className="border p-4 rounded-xl bg-white">
                                                <h4 className="text-sm font-semibold mb-3 text-gray-700">
                                                    {new Date(date).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
                                                </h4>
                                                <div className="grid grid-cols-2 gap-2">
                                                    {availableShowTimes.map(time => {
                                                        const checked = formData.selectedShowTimes[date]?.includes(time) || false;
                                                        return (
                                                            <label key={time} className={`flex items-center gap-2 p-2 rounded-lg ${checked ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'}`}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={checked}
                                                                    onChange={() => handleShowtimeToggle(date, time, !checked)}
                                                                />
                                                                {time}
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Seat Layout Editor */}
                            <div className="space-y-6">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center gap-3">
                                        <div className="p-3 bg-pink-100 rounded-lg">
                                            <FiGrid className="text-2xl text-pink-600" />
                                        </div>
                                        <h3 className="text-xl font-semibold text-gray-800">
                                            Seat Layout Configuration
                                        </h3>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <button
                                            onClick={() => handleZoom('out')}
                                            className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 disabled:opacity-50 transition-colors"
                                            disabled={zoom <= 0.7}
                                        >
                                            -
                                        </button>
                                        <span className="text-sm w-16 text-center">Zoom: {Math.round(zoom * 100)}%</span>
                                        <button
                                            onClick={() => handleZoom('in')}
                                            className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 disabled:opacity-50 transition-colors"
                                            disabled={zoom >= 1.5}
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>

                                <div className="flex gap-4 mb-4 text-xs text-gray-600">
                                    <div className="flex items-center gap-1">
                                        <div className="w-4 h-4 border border-emerald-500"></div> Available
                                    </div>
                                    <div className="flex items-center gap-1">
                                        <div className="w-4 h-4 bg-gray-300 border border-gray-400"></div> Blocked
                                    </div>
                                </div>

                                {formData.seatLayout.length > 0 ? (
                                    <div className="overflow-auto" onWheel={handleWheel}>
                                        <div
                                            className="mx-auto bg-gray-50 p-6 rounded-xl"
                                            style={{
                                                transform: `scale(${zoom})`,
                                                transformOrigin: 'top center',
                                                width: 'fit-content'
                                            }}
                                        >
                                            {formData.seatLayout.map((section, sIdx) => (
                                                <div key={sIdx} className="mb-8">
                                                    <h3 className="text-center font-poppins font-medium text-sm text-black mb-2">
                                                        {section.Name} {section.Price > 0 && `- Rs. ${section.Price}`}
                                                    </h3>

                                                    <div className="flex flex-col items-center">
                                                        {Array.from(new Set(section.Seats.map((s) => s.Row))).map((row) => {
                                                            const rowKey = `${sIdx}_${row}`;
                                                            const isBlocking = section.Seats.filter(s => s.Row === row && s.Col !== 'X').every(s => s.Stat === 0);

                                                            return (
                                                                <div key={row} className="flex items-center mb-1">
                                                                    <span className="w-6 text-xs font-medium mr-1">{row}</span>
                                                                    <div className="flex">
                                                                        {section.Seats.filter((s) => s.Row === row).map((seat, seatIdx) => {
                                                                            const globalSeatIdx = section.Seats.findIndex(
                                                                                (s) => s.Row === seat.Row && s.Col === seat.Col
                                                                            );

                                                                            if (seat.Col === 'X') {
                                                                                return <div key={seatIdx} className="w-5 h-5 mx-px" />;
                                                                            }

                                                                            return (
                                                                                // <div
                                                                                //     key={seatIdx}
                                                                                //     onClick={() => toggleSeat(sIdx, globalSeatIdx)}
                                                                                //     className={getSeatStyle(seat.Stat, isBlocking && seat.Stat === 1)}
                                                                                // >
                                                                                //     {seat.Col}
                                                                                // </div>

                                                                                <div
                                                                                    key={seatIdx}
                                                                                    onClick={seat.Stat === 2 ? undefined : () => toggleSeat(sIdx, globalSeatIdx)}
                                                                                    className={`${getSeatStyle(seat.Stat, isBlocking && seat.Stat === 1)} ${seat.Stat === 2 ? 'cursor-not-allowed opacity-60' : ''}`}
                                                                                    title={seat.Stat === 2 ? 'Booked Seat - Cannot Modify' : ''}
                                                                                >
                                                                                    {seat.Col}
                                                                                </div>

                                                                            );
                                                                        })}
                                                                    </div>

                                                                    {/* {section.Seats.some(s => s.Row === row && s.Col !== 'X') && (
                                                                        <input
                                                                            type="checkbox"
                                                                            className="ml-2"
                                                                            checked={isBlocking}
                                                                            onChange={(e) => handleRowCheckboxChange(sIdx, row, e.target.checked)}
                                                                        />
                                                                    )} */}





{/* // In your JSX where you determine if the row checkbox should be checked: */}
{section.Seats.some(s => s.Row === row && s.Col !== 'X') && (
    <input
        type="checkbox"
        className="ml-2"
        checked={
            // Check if all toggleable seats in the row are blocked
            (() => {
                const toggleableSeats = section.Seats.filter(s => 
                    s.Row === row && s.Col !== 'X' && s.Stat !== 2 && s.Stat !== 3
                );
                const blockedSeats = toggleableSeats.filter(s => s.Stat === 0);
                return toggleableSeats.length > 0 && blockedSeats.length === toggleableSeats.length;
            })()
        }
        onChange={(e) => handleRowCheckboxChange(sIdx, row, e.target.checked)}
    />
)}

                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center py-8 text-gray-500">
                                        Select a showtime to load the seat layout
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {/* Validation & Actions */}
                    <div className="mt-12 pt-8 border-t border-gray-200">
                        {formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) && (
                            <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6 rounded-lg">
                                <div className="flex items-center gap-3">
                                    <svg className="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                    <span className="text-red-700">Please select at least one showtime for each selected date</span>
                                </div>
                            </div>
                        )}

                        <div className="flex flex-col sm:flex-row justify-end gap-4">
                            <button
                                onClick={clearFormData}
                                className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
                            >
                                Reset Configuration
                            </button>
                            <button
                                onClick={updateLayout}
                                disabled={formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) || formData.seatLayout.length === 0}
                                className={`px-6 py-3 rounded-xl transition-all ${formData.selectedDates.some(date => !(formData.selectedShowTimes[date]?.length)) || formData.seatLayout.length === 0
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-black text-white shadow-lg hover:shadow-xl'
                                    }`}
                            >
                                Update Master Layout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MasterSeatEditor;



























